module.exports = __webpack_public_path__ + "static/media/banner-1-my.7ca7fd56.jpg";